import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { AnomalyDetail } from '../../../services/pwd217Api';
import { anomalyBusinessDate } from '../../../utils/anomalyBusinessDate';
import { anomalyDocumentType } from '../../../utils/anomalyDocumentType';

interface Props { details: AnomalyDetail[]; }

// PWD217 reviews purchasing details; only the supervisor explanation is saved.
const columns: ColumnsType<AnomalyDetail> = [
  { title: <span data-contract-field="ui_detail_line_no">項次</span>, dataIndex: 'line_no', key: 'line_no', width: 60, align: 'center' },
  { title: <span data-contract-field="ui_anomaly_code">異常代號</span>, dataIndex: 'anomaly_code', key: 'anomaly_code', width: 120 },
  { title: <span data-contract-field="ui_anomaly_description">說明</span>, dataIndex: 'desc', key: 'desc' },
  { title: <span data-contract-field="ui_scheduled_date">預計作業日期</span>, dataIndex: 'sched_date', key: 'sched_date', width: 150,
    render: (value: string | null) => anomalyBusinessDate(value) || '--' },
  { title: <span data-contract-field="ui_generated_doc_type">產生單據類型</span>, dataIndex: 'doc_type_code', key: 'doc_type_code', width: 120,
    render: (_text: string, detail: AnomalyDetail) => anomalyDocumentType(detail.seq_no) },
];

const Pwd217DetailPanel: React.FC<Props> = React.memo(({ details }) => (
  <Table<AnomalyDetail> rowKey="line_no" columns={columns} dataSource={details}
    size="small" pagination={false} scroll={{ y: 200 }} locale={{ emptyText: '無異常說明明細' }} />
));
Pwd217DetailPanel.displayName = 'Pwd217DetailPanel';
export default Pwd217DetailPanel;
